import ModuleRoutes from './modules/routes';
import { configureStore } from './store/configureStore';
import { PersistGate } from 'redux-persist/integration/react';
import { Routes, BrowserRouter } from "react-router-dom";
import ScrollToTop from "./modules/common/ScrollToTop";
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import DynamicHead from './components/DynamicHead';

import './assets/css/bootstrap.min.css';
import './assets/css/style.css';
import './assets/css/responsive.css';

const { store, persistor } = configureStore();

function App() {
  const basename =
    window.location.hostname === "socsurvey.tatacommunications.com"
      ? "/"
      : "/soc-survey/frontend";

  return (
    <Provider store={store}>
      <HelmetProvider>
        <BrowserRouter basename={basename}>
          <DynamicHead />

          <PersistGate loading={null} persistor={persistor}>
            <ScrollToTop>
              <Routes>
                {ModuleRoutes()}
              </Routes>
            </ScrollToTop>
          </PersistGate>
        </BrowserRouter>
      </HelmetProvider>
    </Provider>
  );
}

export default App;
